/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScimResource } from './scimResource';
import { BaseResourceObject } from './baseResourceObject';
import { StatusWrapper } from './statusWrapper';


export interface BulkOperation { 
    method?: BulkOperation.MethodEnum;
    bulkId?: string;
    version?: string;
    path?: string;
    data?: ScimResource;
    location?: string;
    response?: BaseResourceObject;
    status?: StatusWrapper;
}
export namespace BulkOperation {
    export const MethodEnum = {
        Post: 'POST',
        Put: 'PUT',
        Patch: 'PATCH',
        Delete: 'DELETE'
    } as const;
    export type MethodEnum = typeof MethodEnum[keyof typeof MethodEnum];
}


